export default __webpack_public_path__ + "static/media/guideline.0f2c7a67.png";